<p-confirmdialog #cd />
<p-confirmPopup key="DT"></p-confirmPopup>
<ng-container *ngIf="messageException !== ''">
    <div class="text-sm">
        {{messageException}}
    </div>
</ng-container>
<p-table #dt [dataKey]="dataKey" [columns]="metadataTable" [value]="dataTable" [tableStyle]="{ 'min-width': '50rem' }"
    size="small" [stripedRows]="stripedRows" (sortFunction)="customSort($event)" [customSort]="true"
    [editMode]="editMode" [globalFilterFields]="filtrosGlobal" scrollable="true" scrollHeight="600px"
    styleClass="border-1 border-200" showGridlines selectionMode="single" [paginator]="paginator"
    [rowsPerPageOptions]="rowsPerPageOptions" [rows]="rowsPerPageOptions[0]" [resizableColumns]="true"
    columnResizeMode="expand" [virtualScroll]="virtualScroll">

    <!-- , 'table-layout': 'fixed' -->
    <!-- #region CAPTION -->

    <ng-template #caption>
        <div class="flex gap-2 align-items-center">

            <!-- #region BUSCAR GLOBAL -->

            <p-iconfield>
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" pInputText type="text" (input)="dt.filterGlobal($event.target['value'], 'contains')"
                    placeholder="Buscar" pSize="small" />
            </p-iconfield>

            <!-- #endregion -->


            <!-- #region BORRAR TODOS LOS FILTROS -->

            <p-button icon="pi pi-filter-slash" pTooltip="Quitar filtros" severity="info" aria-label="Save"
                (onClick)="dt.reset()" size="small" *ngIf="btnResetFiltros"></p-button>

            <!-- #endregion -->

            <!-- #region EXPORTAR A EXCEL -->

            <p-button icon="pi pi-file-excel" pTooltip="Exportar a Excel" severity="success" aria-label="Exportar"
                (onClick)="export()" size="small" *ngIf="exportDataCsv"></p-button>

            <!-- #endregion -->


            <!-- #region AGREGAR NUEVA FILA -->

            <p-button icon="pi pi-plus" pTooltip="Agregar" severity="success" aria-label="Save"
                (onClick)="addEmptyRow()" size="small" *ngIf="addRow"></p-button>

            <!-- #endregion -->

            <p-button icon="pi pi-trash" pTooltip="Eliminar seleccionados" severity="danger" *ngIf="deleteRow"
                (onClick)="deleteCheckList()" size="small"></p-button>
            <!-- [disabled]="listCheckItems.length === 0" -->
            <!--  *ngIf="deleteMode === 'list'" -->

            <p-button icon="pi pi-database" pTooltip="Ver datos" ariaLabel="save" (onClick)="viewData()"
                size="small"></p-button>

            <ng-container *ngIf="buttonCaption.length !== 0">
                <p-button *ngFor="let item of buttonCaption" [icon]="item.icon" [label]="item.label"
                    [variant]="item.variant" [severity]="item.severity" (onClick)="item.function()" size="small"
                    class="caption" [pTooltip]="item.pTooltip" [disabled]="item.disabled || btnDisabled"></p-button>
            </ng-container>

            <ng-container *ngIf="optionTable?.caption as opciones">

                <p-button *ngIf="opciones?.addRow" icon="pi pi-plus" (onClick)="addEmptyRow()" severity="success"
                    size="small" pTooltip="Nuevo"></p-button>

                <!-- <p-button *ngIf="opciones?.deleteSelectRow" icon="pi pi-trash" pTooltip="Eliminar seleccionados"
                    severity="danger" (onClick)="deleteCheckList(rowData)" size="small"></p-button> -->

                <p-button *ngFor="let item of opciones?.buttons" [icon]="item.icon" [label]="item.label"
                    [variant]="item.variant" [severity]="item.severity" (onClick)="item.function()" size="small"
                    class="caption" [pTooltip]="item.pTooltip"></p-button>

            </ng-container>

            <ng-container *ngTemplateOutlet="addCaption"></ng-container>

            <div class="leyendas-container flex align-items-center ml-auto">
                <ng-container *ngFor="let leyenda of customLeyendasHex">
                    <div class="leyenda-item flex align-items-center ml-4">
                        <div class="leyenda-color-circle mr-1" [style.background]="leyenda.color"></div>
                        <span class="text-500" style="font-size: 10px;">{{ leyenda.texto }}</span>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-template>

    <!-- #endregion -->

    <!-- #region HEADER -->

    <ng-template #header let-columns>
        <tr class="bg-blue-300">
            <th *ngIf="checkInicial" class="first-th header-table bg-blue-50">
                <p-checkbox binary="true" [(ngModel)]="checkAllState" (onChange)="checkAll($event)" size="small"
                    *ngIf="checkAllOn"></p-checkbox>
            </th>
            <ng-container *ngTemplateOutlet="addHeaderStart"></ng-container>
            <th pResizableColumn *ngFor="let col of columns" class="header-table bg-blue-50" [ngStyle]="col.styleColumn"
                [ngClass]="{ 'hidden': col.visible }">
                <!-- {{ col.header.title }} -->
                <div class="header-table-title" [ngStyle]="col.styleColumn">
                    <span [innerHTML]="col.header.title"></span>
                    <p-checkbox binary="true" [(ngModel)]="checkAllStateCabecera"
                        (onChange)="checkAllPorCabecera($event, col.field.output)" size="small"
                        *ngIf="col.type === 'checkboxAll'">
                    </p-checkbox>
                    @if(iconSave){
                    <p-button icon="pi pi-save" class="add-button" *ngIf="col.type == 'checkList'" size="small"
                        [disabled]="!checkLists?.[col.field.output] ||checkLists?.[col.field.output]?.length === 0"
                        (click)="col?.function?.(checkLists?.[col.field.output])"></p-button>
                    @if(['s-select','s-datetime','s-input','s-area','inputEdit','s-number'].includes(col.type) &&
                    col?.buttonSave){
                    <p-button icon="pi pi-save" class="add-button" size="small"
                        [disabled]="!checkLists?.[col.field.output] || checkLists?.[col.field.output]?.length === 0"
                        (click)="col?.buttonSave?.(checkLists?.[col.field.output])">
                    </p-button>
                    }
                    @if (col.header.type === "row") {
                    <p-sortIcon [pSortableColumn]="col.field.output" [field]="col.field.output"
                        *ngIf="col.type != 'checkList'" />
                    <p-columnFilter type="text" [field]="col.field.output" display="menu" matchMode="contains"
                        *ngIf="col.type != 'checkList'" />
                    }
                    }
                </div>
            </th>
            <th *ngIf="editMode==='row'" class="header-table bg-blue-50"></th>
        </tr>
        <!-- <tr>
            <th></th>
            <th *ngFor="let col of columns">
                <p-columnFilter type="text" [field]="col.field.output" placeholder="Search by name"
                    ariaLabel="Filter Name"></p-columnFilter>
            </th>
        </tr> -->
    </ng-template>

    <!-- #endregion -->

    <!-- #region BODY -->

    <ng-template #body let-rowData let-columns="columns" let-editing="editing" let-ri="rowIndex">

        <tr [pEditableRow]="rowData" *ngIf="rowData.statustable !== 'D'" [ngStyle]="styleRow?.(rowData)">


            <!-- ELEMENTOS FUNCIONALES DE LA TABLA -->

            <td *ngIf="checkInicial">
                <div class="first-th flex align-items-center justify-content-center gap-2">

                    <p-checkbox binary="true" [(ngModel)]="rowData.checked" size="small"
                        (onChange)="onChangeListCheck()" *ngIf="checkOn"></p-checkbox>

                    <p-button icon="pi pi-trash" severity="danger" (onClick)="deleteRowByCode(rowData.codeinterno)"
                        *ngIf="deleteRow" size="small"></p-button>

                    <ng-container *ngFor="let item of funcionalButtons">
                        <p-button [icon]="item.icon" (onClick)="item.function(rowData)" [severity]="item.severity"
                            size="small"
                            [pTooltip]="item.pTooltipDynamic ? item.pTooltipDynamic(rowData) : item.pTooltip"
                            [disabled]="item.disabled ? item.disabled(rowData) : false"></p-button>
                    </ng-container>

                    <ng-container *ngIf="optionTable?.body as opciones">

                        <p-button *ngFor="let item of opciones?.buttons" [icon]="item.icon" [label]="item.label"
                            [variant]="item.variant" [severity]="item.severity"
                            (onClick)="item.function?.(); item.functionRow?.(rowData)" size="small" class="caption"
                            [pTooltip]="item.pTooltip" [disabled]="item.disabled?.(rowData)"></p-button>

                    </ng-container>

                </div>
            </td>

            <!-- FIN ELEMENTOS FUNCIONALES DE LA TABLA -->

            <ng-container *ngTemplateOutlet="addBodyStart; context: { row: rowData }"></ng-container>

            <!-- #region MODO DE EDICION POR FILA -->

            <ng-container *ngIf="editMode==='row' || editMode===null">
                <td *ngFor="let col of columns" [ngClass]="{ 'hidden': col.visible }"
                    [ngStyle]="col?.dynamicStyleColumn ? col.dynamicStyleColumn(rowData) : col?.styleColumn">
                    <p-cellEditor>
                        <ng-template #input>
                            <input pInputText type="text" [(ngModel)]="rowData[col.field.input]" pSize="small" />
                        </ng-template>
                        <ng-template #output>
                            <!-- [ngStyle]="col.styleColumn" -->
                            <div
                                style="font-size: 11px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap; font-weight: 350;">

                                <ng-container
                                    *ngIf="col.type === 'text' || (col.type === 'inputEdit' && rowData[col.modoOutput] === false)">
                                    {{rowData[col.field.output]}}
                                </ng-container>

                                <ng-container *ngIf="col.type === 'date' || col.type === 'datetime'">
                                    {{ rowData[col.field.output] ? util.formatearfecha(rowData[col.field.output],
                                    'dd/mm/yyyy') : null}}
                                </ng-container>

                                <ng-container *ngIf="col.type === 'int'">
                                    {{ formatNumber(rowData[col.field.output], 'int')}}
                                </ng-container>

                                <ng-container *ngIf="col.type === 'decimal'">
                                    {{ convertToDecimal(rowData[col.field.output])}}
                                </ng-container>

                                <ng-container *ngIf="col.type === 'porcentaje'">
                                    {{ formatPorcentaje(rowData[col.field.output], col.maxFractionDigits ?? 2) }}
                                </ng-container>

                                <ng-container *ngIf="col.type === 'b-decimal'">
                                    <div class="align-control">
                                        <p-inputNumber [(ngModel)]="rowData[col.field.input]" [minFractionDigits]="2"
                                            [maxFractionDigits]="4" mode="decimal" [useGrouping]="true"
                                            class="w-12rem text-xs" [disabled]="col.disabled?.(rowData)"
                                            (onInput)="col.onChange?.(rowData); onChangeInput($event, rowData.codeinterno)">
                                        </p-inputNumber>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="(col.type === 'selectEdit' && rowData[col.modoOutput] === false)">
                                    {{ rowData[col.field.output]?.label ? rowData[col.field.output].label :
                                    (rowData[col.field.output]
                                    ?
                                    rowData[col.field.output] : '') }}
                                </ng-container>

                                <ng-container *ngIf="col.type === 'checkbox'">
                                    <div class="align-control" style="padding-bottom: 8px; padding-top: 8px;"
                                        [pTooltip]="col?.pTooltip?.(rowData)" [escape]="false">
                                        <p-checkbox [(ngModel)]="rowData[col.field.output]" size="small" [binary]="true"
                                            [appDisabled]="col.disabled?.(rowData) || (col.validar && rowData[col.validar] === true) || false"
                                            [ngClass]="{ 'checkbox-disabled': rowData[col.validar] === true }"
                                            (onChange)="col.onChange?.(rowData)"
                                            *ngIf="col.visibleoutput ? col.visibleoutput(rowData) : true" />
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="col.type === 'checkboxAll'">
                                    <div class="align-control" style="padding-bottom: 8px; padding-top: 8px;">
                                        <p-checkbox [(ngModel)]="rowData[col.field.output]" size="small" [binary]="true"
                                            (onChange)="col.onChange?.(rowData)" />
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'checkboxDisabled'">
                                    <div class="align-control" style="padding-bottom: 8px; padding-top: 8px;">
                                        <p-checkbox #cbx [(ngModel)]="rowData[col.field.output]" size="small"
                                            [binary]="true" (onChange)="col.onChange?.(rowData)" [disabled]="true"
                                            [appDisabled]="true" [ngClass]="{ 'checkbox-disabled': true }" />
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'input_save'">
                                    <div class="align-control">
                                        <input pInputText type="text" [(ngModel)]="rowData[col.field.output]"
                                            pSize="small" />
                                        <span style="padding: 0 .1rem"></span>
                                        <p-button icon="pi pi-save" size="small"
                                            (onClick)="functionClick(col,rowData)"></p-button>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'b-input'">
                                    <div class="align-control">
                                        <input pInputText type="text" [(ngModel)]="rowData[col.field.input]"
                                            class="w-12rem text-xs" [maxlength]="col.length ? col.length : 50"
                                            [disabled]="col.disabled?.(rowData)"
                                            (onInput)="col.onChange?.(rowData);onChangeInput($event, rowData.codeinterno)" />
                                        <span style="padding: 0 .1rem"></span>
                                        <p-button *ngIf="col.buttonSave" icon="pi pi-save" size="small"
                                            (onClick)="col.buttonSave?.(rowData)" [disabled]="col.disabled?.(rowData)">
                                        </p-button>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'icon'">
                                    <div class="align-control">
                                        <img [src]="col.function?.(rowData)" width="16" height="16" alt="estado" />
                                    </div>
                                    <div class="align-control">
                                        <img [src]="col.function?.(rowData)" width="16" height="16" alt="estado" />
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'button'">
                                    <div class="align-control">
                                        <p-button [icon]="col.buttonConfig.icon" size="small"
                                            [severity]="col.buttonConfig.severity"
                                            *ngIf="col.visibleoutput ? col.visibleoutput(rowData) : true"
                                            (onClick)="col.buttonConfig.function?.(rowData)"
                                            [pTooltip]="col.pTooltip ? col.pTooltip(rowData) : null"
                                            [disabled]="col.buttonConfig?.disabled ? col.buttonConfig.disabled(rowData) : false"></p-button>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'b-select'">
                                    <p-select [options]="col.itemSelect" [(ngModel)]="rowData[col.field.input]"
                                        showClear="true" filter="true" appendTo="body" virtualScroll="true"
                                        class="w-12rem text-xs" styleClass="text-xs" size="small"
                                        virtualScrollItemSize="20"
                                        (onChange)="col.onChange?.(rowData);onChangeSelect($event, rowData.codeinterno, col.itemSelect, col.field.output)"
                                        [disabled]="col.disabled?.(rowData)" />
                                    <span style="padding: 0 .1rem"></span>
                                    <p-button *ngIf="col.buttonSave" icon="pi pi-save" size="small"
                                        (onClick)="col.buttonSave?.(rowData)"
                                        [disabled]="col.disabled?.(rowData)"></p-button>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'b-datetime'">
                                    <p-datePicker [(ngModel)]="rowData[col.field.input]" appendTo="body"
                                        dateFormat="dd/mm/yy" size="small" [showTime]="col.visible"
                                        class="w-8rem text-xs" inputStyleClass="w-full text-xs" styleClass="w-8rem"
                                        showButtonBar="true" clearButtonStyleClass="p-button-sm"
                                        [disabled]="col.disabled?.(rowData)"
                                        (onSelect)="col.onChange?.(rowData);onChangeInput($event, rowData.codeinterno)"></p-datePicker>
                                    <span style="padding: 0 .1rem"></span>
                                    <p-button icon="pi pi-save" size="small" (onClick)="col.buttonSave?.(rowData)"
                                        [disabled]="col.disabled?.(rowData)"></p-button>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'checkList'">
                                    <div class="align-control" style="padding-bottom: 8px; padding-top: 8px;"
                                        [pTooltip]="col.pTooltip(rowData)" [escape]="false">
                                        <p-checkbox [(ngModel)]="rowData[col.field.output]" [binary]="true"
                                            [appDisabled]="rowData[col.validar] === true"
                                            [ngClass]="{ 'checkbox-disabled': rowData[col.validar] === true }"
                                            size="small" *ngIf="col.visibleoutput ? col.visibleoutput(rowData) : true"
                                            (onChange)="col.onChange?.(rowData);onChangeCheckList($event, rowData, col)">
                                        </p-checkbox>
                                    </div>
                                </ng-container>

                                <div class="w-auto"
                                    *ngIf="col.type === 'inputEdit' && rowData[col.modoOutput] === true">
                                    <input pInputText [(ngModel)]="rowData[col.field.output]" type="text"
                                        [disabled]="getDisabledSelectEdit(rowData?.[col.condicion],rowData?.[col.descCondicion])"
                                        [style]="'width:' + col.maxWidth" />
                                </div>

                                <div class="w-auto"
                                    *ngIf="col.type === 'selectEdit' && rowData[col.modoOutput] === true">
                                    <p-select [(ngModel)]="rowData[col.field.output]" [options]="col.itemSelect"
                                        appendTo="body" placeholder="Nombre" styleClass="w-full" [filter]="true"
                                        [showClear]="true" optionLabel="label"
                                        [disabled]="getDisabledSelectEdit(rowData?.[col.condicion],rowData?.[col.descCondicion])"
                                        [virtualScroll]="col.virtualScroll" [readonly]="col.inputStatus === 'lock'">
                                    </p-select>
                                </div>

                                <div class="row-button-table flex align-items-center justify-content-center w-auto"
                                    *ngIf="col.type === 'icon#'">
                                    <div class="leyenda-icon-container">
                                        <div class="leyenda-icon-table" [style.background]="col.function(rowData)">
                                        </div>
                                    </div>
                                </div>

                                <ng-container *ngIf="col.type === 's-select'">
                                    <p-select [options]="col.itemSelect" [(ngModel)]="rowData[col.field.input]"
                                        [showClear]="col.showClear" filter="true" appendTo="body" virtualScroll="true"
                                        class="w-12rem text-xs" styleClass="text-xs" size="small"
                                        virtualScrollItemSize="20"
                                        (onChange)="col.onChange?.(rowData);onChangeGeneric($event, rowData, col, rowData.codeinterno)"
                                        [disabled]=" col.disabled?.(rowData)" />

                                    @if(col.iconCaption && (col.iconCaption.visible ? col.iconCaption.visible(rowData) :
                                    true)){
                                    <i [class]="getIconClass(col.iconCaption)" class="cursor-pointer text-lg ml-2"
                                        [pTooltip]="col.iconCaption.pTooltip ? col.iconCaption.pTooltip(rowData) : ''"
                                        tooltipPosition="top"
                                        (click)="!col.iconCaption.disabled && col.iconCaption.function?.(rowData)">
                                    </i>
                                    }

                                    <span style="padding: 0 .1rem"></span>
                                </ng-container>

                                <ng-container *ngIf="col.type === 's-datetime'">
                                    <p-datePicker [(ngModel)]="rowData[col.field.input]" appendTo="body"
                                        dateFormat="dd/mm/yy" size="small" [showTime]="col.visible"
                                        class="w-8rem text-xs" inputStyleClass="w-full text-xs" styleClass="w-8rem"
                                        showButtonBar="true" clearButtonStyleClass="p-button-sm"
                                        [disabled]="col.disabled?.(rowData)"
                                        (onSelect)="col.onChange?.(rowData);onChangeGeneric($event, rowData, col, rowData.codeinterno)"></p-datePicker>
                                    <span style=" padding: 0 .1rem"></span>
                                </ng-container>

                                <ng-container *ngIf="col.type === 's-input'">
                                    <div class="align-control">
                                        <input pInputText type="text" [(ngModel)]="rowData[col.field.input]"
                                            class="w-12rem text-xs" [maxlength]="col.length ? col.length : 50"
                                            [disabled]="col.disabled?.(rowData)"
                                            (input)="col.onChange?.(rowData);onChangeGeneric($event, rowData, col, rowData.codeinterno)" />
                                        <span style="padding: 0 .1rem"></span>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="col.type === 's-area'">
                                    <div class="align-control">
                                        <textarea pInputText type="text" [(ngModel)]="rowData[col.field.output]"
                                            pTextarea pSize="small" [attr.maxlength]="col.maxLength" [rows]="2"
                                            [readonly]="col.readonly" style="resize: vertical;"
                                            [disabled]="col.disabled?.(rowData)"
                                            (input)="col.onChange?.(rowData);onChangeGeneric($event, rowData, col, rowData.codeinterno)"></textarea>
                                        <span style="padding: 0 .1rem"></span>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="col.type === 's-number'">
                                    <div class="align-control">
                                        <p-inputNumber [(ngModel)]="rowData[col.field.input]" mode="decimal"
                                            [useGrouping]="false" [maxFractionDigits]="col.maxFractionDigits ?? 4"
                                            [minFractionDigits]="col.minFractionDigits ?? 0"
                                            [disabled]="col.disabled?.(rowData)" [attr.maxlength]="col.maxLength"
                                            inputmode="numeric" class="w-12rem text-xs">>
                                        </p-inputNumber>
                                        <span style="padding: 0 .1rem"></span>
                                    </div>
                                </ng-container>

                            </div>
                        </ng-template>
                    </p-cellEditor>
                </td>

                <td *ngIf="editMode && editMode==='row'">

                    <div class=" flex items-center justify-center gap-2">

                        <p-button *ngIf="!editing && editRow" pInitEditableRow icon="pi pi-pencil"
                            (click)="onRowEditInit(rowData)" severity="warn" size="small" pTooltip="Editar"></p-button>

                        <p-button *ngIf="editing" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(rowData)"
                            severity="success" size="small" pTooltip="Confirmar"></p-button>

                        <p-button *ngIf="editing" pCancelEditableRow icon="pi pi-times"
                            (click)="onRowEditCancel(rowData, ri)" severity="danger" size="small"
                            pTooltip="Cancelar"></p-button>

                    </div>

                </td>
            </ng-container>

            <!-- #endregion -->

            <!-- #region MODO EDICION TODAS LAS CELDAS -->

            <ng-container *ngIf="editMode==='cell'">

                <td *ngFor="let col of columns" [pEditableColumn]="rowData[col.field]"
                    [pEditableColumnField]="col.field" [ngClass]="{ 'hidden': col.visible }">
                    <p-cellEditor>

                        <!-- MODO INPUT -->

                        <ng-template #input>

                            <!-- TEXT -->
                            <ng-container *ngIf="col.type === 'text'">
                                <input pInputText type="text" [(ngModel)]="rowData[col.field.input]" pSize="small" />
                            </ng-container>
                            <!-- FIN TEXT -->

                            <!-- FECHA -->
                            <ng-container *ngIf="col.type === 'date'">
                                <p-datePicker [(ngModel)]="rowData[col.field.input]" appendTo="body"
                                    dateFormat="dd/mm/yy" showClear="true" size="small"></p-datePicker>
                            </ng-container>
                            <!-- FIN FECHA -->

                            <!-- NUMBER INT -->
                            <ng-container *ngIf="col.type === 'int'">
                                <!-- {{rowData[col.field.output.replace('_value', '_tipomoneda')] ? "":
                                (rowData[col.field.input.replace('_value', '_tipomoneda')] === "001" ? "S/. " : "$ ") }} -->
                                <p-inputnumber [(ngModel)]="rowData[col.field.input]" mode="decimal" useGrouping="false"
                                    showButtons="true" (onInput)="onChangeInput($event, rowData.codeinterno)"
                                    size="small" />
                            </ng-container>
                            <!-- FIN NUMBER INT -->

                            <!-- NUMBER DECIMAL -->
                            <ng-container *ngIf="col.type === 'decimal'">
                                <!-- {{rowData[col.field.output.replace('_value', '_tipomoneda')] ? "":
                                (rowData[col.field.input.replace('_value', '_tipomoneda')] === "001" ? "S/. " : "$ ") }} -->
                                <p-inputnumber [(ngModel)]="rowData[col.field.input]" mode="decimal" useGrouping="true"
                                    showButtons="true" minFractionDigits="2"
                                    (onInput)="onChangeInput($event, rowData.codeinterno)" size="small" />
                            </ng-container>
                            <!-- FIN NUMBER DECIMAL -->

                            <!-- DROPDOWN -->
                            <ng-container *ngIf="col.type === 'select'">
                                <p-select [options]="col.itemSelect" [(ngModel)]="rowData[col.field.input]"
                                    showClear="true" filter="true" appendTo="body" virtualScroll="true"
                                    class="w-12rem text-xs" styleClass="text-xs"
                                    (onChange)="col.onChange?.(rowData);onChangeSelect($event, rowData.codeinterno, col.itemSelect, col.field.output)"
                                    size="small" virtualScrollItemSize="20" />
                                <!-- class="w-12rem" -->
                            </ng-container>
                            <!-- FIN DROPDOWN -->

                            <!-- DROPDOWN -->
                            <ng-container *ngIf="col.type === 'moneda_monto'">
                                <p-inputnumber [(ngModel)]="rowData[col.field.input]" mode="decimal" useGrouping="true"
                                    showButtons="false" minFractionDigits="2"
                                    (onBlur)="onChangeInput($event, rowData.codeinterno); col.function?.(rowData)"
                                    (keydown.enter)="onChangeInput($event, rowData.codeinterno); col.function?.(rowData)"
                                    class="w-6rem" inputStyleClass="w-full" size="small"
                                    [readonly]="col?.readonly == true" />
                                <p-select [options]="listMoneda" [(ngModel)]="rowData[col.field.coin]" filter="true"
                                    appendTo="body" virtualScroll="true" class="w-6rem"
                                    (onChange)="onChangeSelectCoin($event, rowData.codeinterno, listMoneda, col.field.coin); col.function?.(rowData)"
                                    size="small" [readonly]="col?.readonly == true" />
                            </ng-container>
                            <!-- FIN DROPDOWN -->
                            <ng-container *ngIf="col.type === 'checkList'">
                                <div class="align-control" [pTooltip]="col.pTooltip(rowData)" [escape]="false">
                                    <p-checkbox [(ngModel)]="rowData[col.field.input]" [binary]="true" inputId="binary"
                                        [disabled]="rowData[col.validar] === true"
                                        *ngIf="col.visibleoutput ? col.visibleoutput(rowData) : true"
                                        (onChange)="onChangeCheckList($event, rowData, col)">
                                    </p-checkbox>
                                </div>
                            </ng-container>

                        </ng-template>

                        <!-- FIN MODO INPUT -->

                        <!-- MODO OUTPUT -->

                        <ng-template #output>
                            <ng-container *ngIf="col.type !== 'moneda_monto'">
                                <!-- <div style="text-align: center;"> -->
                                <div style="text-align: left;" class="body-table">{{ rowData[col.field.output] }}</div>

                                <!-- </div> -->
                            </ng-container>

                            <div class="row-button-table flex align-items-center justify-content-center h-10"
                                *ngIf="col.type === 'icon#'">
                                <div class="leyenda-icon-container">
                                    <div class="leyenda-icon-table" [style.background]="col.function(rowData)">
                                    </div>
                                </div>
                            </div>

                            <ng-container *ngIf="col.type === 'moneda_monto'">
                                <div style="text-align: center;" class="body-table">
                                    {{ rowData[col.field.output] }}
                                    {{ getMonedaLabel(rowData[col.field.coin]) }}
                                </div>
                            </ng-container>

                            <ng-container *ngIf="col.type === 'porcentaje'">
                                <div style="text-align: left;" class="body-table">
                                    {{ formatPorcentaje(rowData[col.field.output], col.maxFractionDigits ?? 2) }}
                                </div>
                            </ng-container>

                        </ng-template>

                        <!-- FIN MODO OUTPUT -->

                    </p-cellEditor>
                </td>
            </ng-container>

            <!-- #endregion -->

        </tr>
    </ng-template>

    <!-- #endregion -->

    <!-- #region FOOTER TOTALES -->

    <ng-template #footer let-columns>
        <tr *ngIf="footerTotalFields.length">
            <td *ngIf="checkInicial"></td>
            <td *ngFor="let col of columns" [ngClass]="{ 'hidden': col.visible }">
                {{ footerTotalFields.includes(col.field.output) ? getFooterTotal(col.field.output, col.type) : '' }}
            </td>
            <td *ngIf="editMode==='row'"></td>
        </tr>
    </ng-template>

    <!-- #endregion -->

</p-table>